<template>
  <v-dialog v-model="dialog" width="450" persistent>
    <v-card class="event-form pb-2">
      <v-card-title class="p-3 mb-5" color="primary">
        <v-icon @click="close">
          mdi-close
        </v-icon>
        {{ $t('ViewCalendarItem.CancelReason') }}
      </v-card-title>
      <v-card-text>
        <v-text-field v-model="cancelReason" :counter="50" class="pt-4" :label="$t('ViewCalendarItem.CancelReason')"></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="submit">
          {{ $t('GeneralTranslations.Save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'CancelCallDialog',
  components: {  },
  data() {
    return {
      dialog: false,
      cancelReason: null,
    }
  },
  computed: {
    facility() {
      return this.$store.state.authModule.currentFacilityData
    }
  },

  methods: {
    open() {
      this.dialog = true;
    },

    close() {
      this.dialog = false
      this.cancelReason = null
    },

    async submit() {
      this.$emit('onSubmit', this.cancelReason)
      this.close()
    }
    
  }
}
</script>

<style scoped></style>
